import React, { useState } from 'react';

interface ErrorTestProps {}

const ErrorTest: React.FC<ErrorTestProps> = () => {
    const [shouldThrow, setShouldThrow] = useState(false);

    if (shouldThrow) {
        throw new Error('Test error thrown by ErrorTest component!');
    }

    return (
        <div style={{ padding: '40px', fontFamily: 'Arial, sans-serif' }}>
            <h1>Error Boundary Test Page</h1>
            <p>Click the button below to trigger an error and test the ErrorBoundary component.</p>
            
            <button 
                onClick={() => setShouldThrow(true)}
                style={{
                    padding: '15px 30px',
                    fontSize: '16px',
                    backgroundColor: '#d32f2f',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    marginTop: '20px'
                }}>
                Throw Test Error
            </button>

            <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                <h3>How to test:</h3>
                <ol>
                    <li>Click the "Throw Test Error" button above</li>
                    <li>The component will throw an error</li>
                    <li>The ErrorBoundary should catch it and display the error page</li>
                    <li>You should see options to "Reload Page" or "Clear Cache & Reload"</li>
                    <li>Click "Reload Page" to return to normal operation</li>
                </ol>
            </div>
        </div>
    );
};

export default ErrorTest;
